import React from "react";
import { RichTextEditor } from "../../../CommonUI/RichTextEditor/RichTextEditor";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
import { StyledFormHelperText } from "./CommonStyled";
import { IssueData } from "../../Utilities/ControlRenderContext";
import { TextEntryFormControl } from "../TextEntryFormControl";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

export class RichTextEditorFormControl extends TextEntryFormControl {
    exportFileName: string = "output";
    readonly __type: string = "Rich Text Edit";

    render() {
        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";

        return (
            <div
                style={{
                    width: this.fullWidth ? "100%" : `${this.width || 200}px`,
                }}
            >
                {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                <RichTextEditor
                    value={this.valueName && this.getFormDataValue(this.valueName)}
                    onChange={(val) => this.valueName && val !== "" && this.setFormDataValue(this.valueName, val)}
                    placeholder={this.placeholderText || "Label"}
                />
                {(issueText || this.hintText) && (
                    <StyledFormHelperText
                        error={Boolean(issueText)}
                        data-testid="issueOrHintText"
                    >
                        {issueText ? issueText : this.hintText}
                    </StyledFormHelperText>
                )}
            </div>
        );
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let dd = new StringDataDefinition();
        dd.name = this.valueName;
        return dd;
    }

    renderEditUI(): JSX.Element | null {
        return <XRichTextEditorUI editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "exportFileName", "__type");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "exportFileName", "__type");
    }
}

function XRichTextEditorUI(props: { editMe: RichTextEditorFormControl }) {
    return (
        <UISpacedBoxContent>
            {props.editMe.renderBaseDataControlEditor(["requiredOnAllOutcomes"])}
            {props.editMe.renderTextControlBasePropertyEditor()}
            <PropertyEditorText
                editObject={props.editMe}
                label={"Export File Name"}
                propertyName={"exportFileName"}
            />
        </UISpacedBoxContent>
    );
}
